export default "__VITE_ASSET__e0a824b7__"